import * as React from "react"

import { cn } from "#Utils/cn"

type BadgeColor =
  | "default"
  | "white"
  | "red"
  | "blue"
  | "green"
  | "purple"
  | "orange"
  | "yellow"
  | "teal"
  | "pink"
  | "hot-pink"

type BadgeProps = React.ComponentPropsWithoutRef<"span"> & {
  color?: BadgeColor
  border?: boolean
  sans?: boolean
}

const colorClassNames: Record<BadgeColor, string> = {
  default: "",
  white: "c-pill--white",
  red: "c-pill--red",
  blue: "c-pill--blue",
  green: "c-pill--green",
  purple: "c-pill--purple",
  orange: "c-pill--orange",
  yellow: "c-pill--yellow",
  teal: "c-pill--teal",
  pink: "c-pill--pink",
  "hot-pink": "c-pill--hot-pink",
}

const Badge = ({
  color = "default",
  border = false,
  sans = false,
  className,
  children,
  ...rest
}: BadgeProps) => {
  return (
    <span
      className={cn(
        "c-pill",
        colorClassNames[color],
        border && "c-pill--border",
        sans && "c-pill--sans",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  )
}

export type { BadgeColor, BadgeProps }
export default Badge
